import { motion } from 'framer-motion';

const PricingSection = () => {
  const pricingData = [
    {
      category: '身体介護',
      items: [
        { service: '20分未満', price: '165円' },
        { service: '20分以上30分未満', price: '245円' },
        { service: '30分以上1時間未満', price: '388円' },
        { service: '1時間以上', price: '564円 + 30分ごとに83円' },
      ],
    },
    {
      category: '生活援助',
      items: [
        { service: '20分以上45分未満', price: '181円' },
        { service: '45分以上', price: '223円' },
      ],
    },
    {
      category: '通院等乗降介助',
      items: [
        { service: '1回につき', price: '99円' },
      ],
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-beige-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            料金案内
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 max-w-2xl mx-auto px-4">
            介護保険適用時の自己負担額（1割負担の場合）
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {pricingData.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-md"
            >
              <h3 className="text-xl sm:text-2xl font-bold text-navy-800 mb-4 sm:mb-6 text-center">
                {category.category}
              </h3>
              <div className="space-y-3 sm:space-y-4">
                {category.items.map((item, idx) => (
                  <div key={idx} className="flex justify-between items-start border-b border-beige-200 pb-3 last:border-b-0 last:pb-0">
                    <span className="text-xs sm:text-sm text-navy-700 flex-1 pr-2 break-words">
                      {item.service}
                    </span>
                    <span className="text-base sm:text-lg font-bold text-coral-600 whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-2xl p-6 sm:p-8 shadow-md"
        >
          <h3 className="text-lg sm:text-xl font-bold text-navy-800 mb-4 sm:mb-6 flex items-center">
            <i className="ri-information-line text-coral-500 mr-2 text-xl sm:text-2xl flex-shrink-0"></i>
            <span>料金に関する注意事項</span>
          </h3>
          <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-navy-700">
            <li className="flex items-start">
              <i className="ri-check-line text-coral-500 mr-2 mt-0.5 flex-shrink-0"></i>
              <span>上記は介護保険1割負担の場合の料金です。2割・3割負担の方は料金が異なります。</span>
            </li>
            <li className="flex items-start">
              <i className="ri-check-line text-coral-500 mr-2 mt-0.5 flex-shrink-0"></i>
              <span>早朝（6時〜8時）、夜間（18時〜22時）は25%加算、深夜（22時〜6時）は50%加算となります。</span>
            </li>
            <li className="flex items-start">
              <i className="ri-check-line text-coral-500 mr-2 mt-0.5 flex-shrink-0"></i>
              <span>初回加算、緊急時訪問看護加算など、各種加算が適用される場合があります。</span>
            </li>
            <li className="flex items-start">
              <i className="ri-check-line text-coral-500 mr-2 mt-0.5 flex-shrink-0"></i>
              <span>詳しい料金については、お気軽にお問い合わせください。</span>
            </li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;
